import { render, staticRenderFns } from "./AppMainPrepend.vue?vue&type=template&id=f171b590&scoped=true&"
import script from "./AppMainPrepend.vue?vue&type=script&lang=js&"
export * from "./AppMainPrepend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f171b590",
  null
  
)

/* custom blocks */
import block0 from "./AppMainPrepend.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
